// --- src/data/listings.js ---
const listings = [
  {
    id: 1,
    title: "Modern Family Home",
    location: "San Diego, CA",
    price: "950000",
    image:
      "https://cdn.pixabay.com/photo/2014/07/10/17/18/large-home-389271_640.jpg",
  },
  {
    id: 2,
    title: "Luxury Villa",
    location: "Beverly Hills, CA",
    price: "2500000",
    image:
      "https://cdn.pixabay.com/photo/2020/12/16/00/10/home-5835289_640.jpg",
  },

  {
    id: 3,
    title: "Luxury Villa",
    location: "Beverly Hills, CA",
    price: "2500000",
    image:
      "https://cdn.pixabay.com/photo/2024/07/05/08/19/living-room-8874235_640.jpg",
  },

  {
    id: 4,
    title: "Luxury Villa",
    location: "Beverly Hills, CA",
    price: "2500000",
    image:
      "https://cdn.pixabay.com/photo/2017/07/17/00/54/house-2511060_640.jpg",
  },

  {
    id: 5,
    title: "Luxury Villa",
    location: "Beverly Hills, CA",
    price: "2500000",
    image:
      "https://cdn.pixabay.com/photo/2017/07/17/00/54/house-2511060_640.jpg",
  },

  {
    id: 6,
    title: "Luxury Villa",
    location: "Beverly Hills, CA",
    price: "2500000",
    image:
      "https://cdn.pixabay.com/photo/2017/07/17/00/54/house-2511060_640.jpg",
  },
];

export default listings;
